import React, { useState } from "react";
import TitledCard from "../../../../components/UI/TitledCard";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import { Slide, withStyles } from "@material-ui/core";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import CurrencyNumber from "../../../../components/UI/CurrencyNumber";
import PercentageNumber from "../../../../components/UI/PercentageNumber";
import Button from "@material-ui/core/Button";
import { AppTheme } from "../../../../theme";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import DialogContent from "@material-ui/core/DialogContent";
import { Close } from "@material-ui/icons";
import { TieredFeeDataBox } from "../index";
import {sortFeeSchedules, toUpperBounded} from "../TieredFeeDataBox/helper";

const styles = {
  expansionPanel: {
    background: "transparent",
    margin: 0,
    borderBottom: `1px solid ${AppTheme.palette.grey[100]}`,
    "&:before": {
      opacity: 0,
    },
  },
  expansionPanelDetails: {
    padding: "0 20px 20px",
    flexFlow: "column",
  },
  expansionPanelExpanded: {
    margin: 0,
    background: AppTheme.palette.grey[100],
  },
  expansionPanelSummary: {
    padding: "0 8px",
    minHeight: 1,
  },
  expansionPanelSummaryExpanded: {
    minHeight: 1,
    background: AppTheme.palette.grey[100],
  },
  table: {
    width: "100%",
    fontSize: 14,
  },
  modalCloseBtn: {
    position: "absolute",
    top: 10,
    right: 10,
  },
};
const AdvisorFeeSummaryCard = (props) => {
  const [expanded, setExpanded] = useState("");
  const [modalOpened, setModalOpened] = useState(false);
  const [feeScheduleBeingEdited, setFeeScheduleBeingEdited] = useState(null);

  const toggleExpansion = (name) => (event, expanded) => {
    setExpanded(expanded ? name : "");
  };

  const openModal = (entityType) => (e) => {
    setModalOpened(true);
    const feeSchedule =
      entityType === "custodian"
        ? [...props.custodianFees[expanded]]
        : [...props.platformFees];
    setFeeScheduleBeingEdited(feeSchedule);
  };

  const closeModal = () => {
    setModalOpened(false);
    setFeeScheduleBeingEdited(null);
  };

  const onSaveFeeSchedules = () => {
    const entityType = expanded === "platform" ? "platform" : "custodian";
    const entityId = expanded === "platform" ? undefined : Number(expanded);
    props.onSaveFeeSchedules(
      entityType,
      entityId,
      feeScheduleBeingEdited.map(function (fee) {
        const { id, rate, breakpoint } = fee;
        return { id, rate, breakpoint };
      })
    );
    setModalOpened(false);
  };

  const { classes, custodians, custodianFees, platformFees, platformFeeOverrideDisabled } = props;

  return (
    <React.Fragment>
      <TitledCard titleText="Fees">
        {custodianFees &&
          Object.keys(custodianFees).length > 0 &&
          Object.keys(custodianFees).map((custodianId) => {
            const sortedCustodianFees = sortFeeSchedules(
              toUpperBounded(custodianFees[custodianId])
            );
            return (
              <Accordion
                classes={{
                  root: classes.expansionPanel,
                  expanded: classes.expansionPanelExpanded,
                }}
                onChange={toggleExpansion(custodianId)}
                expanded={expanded === custodianId}
                elevation={0}
                key={custodianId}
                square
              >
                <AccordionSummary
                  classes={{
                    root: classes.expansionPanelSummary,
                    expanded: classes.expansionPanelSummaryExpanded,
                  }}
                >
                  <Typography
                    variant={"body1"}
                    color={expanded === custodianId ? "primary" : "default"}
                  >
                    {
                      custodians.find(
                        (custodian) => custodian.id === Number(custodianId)
                      ).name
                    }
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.expansionPanelDetails}>
                  <Table size={"small"} className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <Typography variant={"body1"}>Break Point</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant={"body1"}>Rate</Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sortedCustodianFees.map((fee, index) => {
                        const isLastItem =
                          index === sortedCustodianFees.length - 1;
                        const previousFee =
                          sortedCustodianFees[index - 1] || null;
                        return (
                          <TableRow key={fee.id}>
                            <TableCell>
                              <Typography variant={"caption"}>
                                {isLastItem ? (
                                  "More than"
                                ) : previousFee ? (
                                  <React.Fragment>
                                    <CurrencyNumber
                                      value={previousFee.breakpoint}
                                    />{" "}
                                    to
                                  </React.Fragment>
                                ) : (
                                  "Up to"
                                )}
                              </Typography>
                              <Typography variant={"body1"}>
                                <CurrencyNumber
                                  value={
                                    isLastItem && previousFee
                                      ? previousFee.breakpoint
                                      : fee.breakpoint || 0
                                  }
                                />
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant={"body1"}>
                                <PercentageNumber
                                  value={fee.rate}
                                  needCalculation={false}
                                />
                              </Typography>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                  <Button
                    variant={"outlined"}
                    color={"primary"}
                    style={{ margin: "20px auto 0", width: 70 }}
                    onClick={openModal("custodian")}
                  >
                    EDIT
                  </Button>
                </AccordionDetails>
              </Accordion>
            );
          })}
        {platformFees && platformFees.length > 0 && (
          <Accordion
            classes={{
              root: classes.expansionPanel,
              expanded: classes.expansionPanelExpanded,
            }}
            onChange={toggleExpansion("platform")}
            expanded={expanded === "platform"}
            elevation={0}
            square
          >
            <AccordionSummary
              classes={{
                root: classes.expansionPanelSummary,
                expanded: classes.expansionPanelSummaryExpanded,
              }}
            >
              <Typography
                variant={"body1"}
                color={expanded === "platform" ? "primary" : "default"}
              >
                Platform Fee
              </Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.expansionPanelDetails}>
              <Table size={"small"} className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Typography variant={"body1"}>Break Point</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant={"body1"}>Rate</Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortFeeSchedules(toUpperBounded(platformFees)).map((fee, index) => {
                    const isLastItem = index === platformFees.length - 1;
                    const previousFee = platformFees[index] || null;
                    return (
                      <TableRow key={fee.id}>
                        <TableCell>
                          <Typography variant={"caption"}>
                            {isLastItem ? (
                              "More than"
                            ) : previousFee ? (
                              <React.Fragment>
                                <CurrencyNumber
                                  value={previousFee.breakpoint}
                                />{" "}
                                to
                              </React.Fragment>
                            ) : (
                              "Up to"
                            )}
                          </Typography>
                          <Typography variant={"body1"}>
                            <CurrencyNumber
                              value={
                                isLastItem && previousFee
                                  ? previousFee.breakpoint
                                  : fee.breakpoint || 0
                              }
                            />
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant={"body1"}>
                            <PercentageNumber
                              value={fee.rate}
                              needCalculation={false}
                            />
                          </Typography>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
              {
                !platformFeeOverrideDisabled &&
                <Button
                  variant={"outlined"}
                  color={"primary"}
                  style={{ margin: "20px auto 0", width: 70 }}
                  onClick={openModal("platform")}
                >
                  EDIT
                </Button>
              }
            </AccordionDetails>
          </Accordion>
        )}
      </TitledCard>
      <Dialog
        open={modalOpened}
        TransitionComponent={Slide}
        TransitionProps={{ direction: "up" }}
        onClose={closeModal}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        scroll={"paper"}
        classes={{ paper: classes.paper }}
      >
        <DialogTitle id="household-settings-modal-title">
          Edit Fees
          <IconButton
            className={classes.modalCloseBtn}
            aria-label="Close"
            onClick={closeModal}
          >
            <Close color="primary" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TieredFeeDataBox
            title={""}
            description={"Changes will apply only to the selected advisor"}
            hideDataBoxStyle={true}
            feeSchedules={feeScheduleBeingEdited}
            onSaveFeeSchedules={onSaveFeeSchedules}
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

AdvisorFeeSummaryCard.propTypes = {
  custodians: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      interface: PropTypes.string,
    })
  ),
  platformFees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      breakpoint: PropTypes.number,
      rate: PropTypes.number,
    })
  ),
  onSaveFeeSchedules: PropTypes.func.isRequired,
  platformFeeOverrideDisabled: PropTypes.bool.isRequired
};

export default withStyles(styles)(AdvisorFeeSummaryCard);



// WEBPACK FOOTER //
// ./src/containers/Cy/components/AdvisorFeeSummaryCard/index.jsx